import React from "react";

class InformationAboutWork extends React.Component {
  getSnlLinkMarkup(artist) {
    return this.showSnlLink(artist) ? (
      <a href={this.props.artistLink.url}>{this.props.artistLink.name}</a>
    ) : (
      <div>{this.props.cmsData.noInformationText}</div>
    );
  }

  showSnlLink(artist) {
    return (
      !!this.props.artistLink &&
      !!this.props.artistLink.url &&
      this.props.artistLink.name === artist
    );
  }

  getEncyclopediaLinkHeading() {
    return this.props.encyclopediaLinkHeading !== undefined &&
      this.props.encyclopediaLinkHeading !== ""
      ? this.props.encyclopediaLinkHeading
      : this.props.cmsData.nklText;
  }

  render() {
    let dateFrom = this.props.item["artifact.ingress.production.fromYear"];
    let dateTo = this.props.item["artifact.ingress.production.toYear"];
    let artist = this.props.item["artifact.ingress.producer"];
    let id = this.props.item["identifier.id"];
    let size = this.props.info.measureDescription;
    let title = this.props.item["artifact.ingress.title"];
    let acquisition = this.props.info.eventWrap
      ? this.props.info.eventWrap.acquisition
      : null;
    let technique = this.props.info.material
      ? this.props.info.material.comment
      : null;
    let snlLink = this.getSnlLinkMarkup(artist);
    let encyclopediaLinkHeading = this.getEncyclopediaLinkHeading();

    return (
      <div className="gallery-carousel-text">
        {!this.props.apiObjectError ? (
          <div>
            {title && 
            <h2>
              {title}

              {(this.props.isVersions || this.props.isSeries) &&
                !this.props.multipleActive && (
                  <span className="normal">
                    {" "}
                    ({this.props.numberInSeries + 1}/{this.props.multipleTotal})
                  </span>
                )}
              {this.props.multipleActive ? (
                <span className="normal">
                  {" "}
                  ({this.props.slide + 1}/{this.props.viewItems.length})
                </span>
              ) : (
                ""
              )}
            </h2>
             }
            {this.props.isVersions ||
            this.props.isSeries ||
            this.props.multipleActive ? (
              <div className="gallery-is-multiple">
                {this.props.isSeries && (
                  <div>
                    <div className="gallery-series">Serie</div>
                  </div>
                )}
                <a className="btn-link" onClick={this.props.toggleVersions}>
                  {!this.props.multipleActive &&
                    this.props.isVersions &&
                    this.props.cmsData.openVersions}
                  {this.props.multipleActive &&
                    this.props.isVersions &&
                    this.props.cmsData.endVersions}
                  {!this.props.multipleActive &&
                    this.props.isSeries &&
                    this.props.cmsData.openSeries}
                  {this.props.multipleActive &&
                    this.props.isSeries &&
                    this.props.cmsData.endSeries}
                </a>
              </div>
            ) : null}

            {artist && (
              <div>
                <span>{this.props.cmsData.artistText}: </span>
                {artist}
              </div>
            )}
            <div>
              <span>{this.props.cmsData.dateText}: </span>
              {dateFrom ? (
                <React.Fragment>
                  {dateFrom} {dateTo && dateTo != dateFrom && " - " + dateTo}
                </React.Fragment>
              ) : (
                this.props.cmsData.noDateText
              )}
            </div>
            {technique && (
              <div>
                <span>{this.props.cmsData.technicText}: </span>
                {technique}
              </div>
            )}
            {artist && (
              <div>
                <span>{this.props.cmsData.measureText}: </span>
                {size}
              </div>
            )}
            {acquisition ? (
              <div>
                <span>{this.props.cmsData.acquireText}: </span>
                {acquisition}
              </div>
            ) : null}
            {id && (
              <div>
                <span>{this.props.cmsData.inventoryNrText}: </span>
                {id}
              </div>
            )}

            <div className="snl">
              <span>{encyclopediaLinkHeading}:</span>
              {snlLink}
            </div>
          </div>
        ) : (
          <h3>{this.props.cmsData.noContactText}</h3>
        )}
      </div>
    );
  }
}

export default InformationAboutWork;
